// Message lisible d'une erreur HTTP, commun aux services du mode autonome.

/** Message lisible d'une erreur HTTP : le backend place le texte destiné à l'utilisateur dans `detail`. */
export const apiErrorMessage = (error: any, fallback: string): string => {
    const detail = error?.response?.data?.detail;
    if (typeof detail === 'string' && detail.trim()) return detail;
    if (Array.isArray(detail)) {
        const messages = detail.map((d: any) => (typeof d === 'string' ? d : d?.msg)).filter(Boolean);
        if (messages.length) return messages.join('\n');
    }
    if (error?.code === 'ECONNABORTED') return 'Le serveur ne répond pas. Réessayez dans un instant.';
    if (error?.request && !error?.response) return 'Serveur injoignable.';
    return fallback;
};
